import Scene from './Scene'
import Model from '@/objects/Model'
import config from '@/config/end'

export default class EndScene extends Scene {
  name = 'EndScene'

  constructor (stage) {
    super()

    this.stage = stage
    this.createEnvironment()
  }

  createEnvironment () {
    const { path, rotation, position } = config.environment
    this.environment = new Model(path)
    this.environment.rotateY(rotation)
    this.environment.position.copy(position)
  }

  start () {
    const { x, y, z } = config.camera
    const { background, fog } = config.scene

    this.stage.add(this.environment)

    this.stage.setCameraPosition(x, y, z)
    this.stage.changeBackground(background)
    this.stage.changeFogColor(fog.color)
    this.stage.changeFogDistance(fog.near, fog.far)
  }

  stop () {
    this.stage.remove(this.environment)
  }
}
